module.exports = __webpack_public_path__ + "img/route_receiver_letter_2.23d8f2e5.png";